import { useState, useEffect } from "react";
import { fetchSubjects } from "../services/fetchSubjects";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function useFetchSubjects() {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const { auth, setCommonWarning } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // console.log("useFetchSubjects called");

    const loadSubjects = async () => {
      try {
        const data = await fetchSubjects(auth.token);
        // setSubjects(data);
        if (data.status === 200) {
          const fnldata = data.data.map((subject) => ({
            id: subject.id,
            name: subject.subject,
            image: `${process.env.REACT_APP_PUBLIC_API_URL}${subject.thumbnail}`,
            is_purchased: subject.is_purchased,
          }));
          setSubjects(fnldata);
        } else if (data.status === 400) {
          setCommonWarning(data.message);
        } else if (data.status === 401) {
          navigate("/login");
          return []; // return empty if unauthorized
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching subjects:", error);
      }
    };

    loadSubjects();
  }, [auth]);

  return [subjects, loading];
}

export default useFetchSubjects;
